"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => Math.random().toString(16).slice(2);
